import * as Page from 'pages';

export const navigations = [
  {
    path: '/',
    exact: true,
    component: Page.Dashboard,
  },
  {
    path: '/cpap/register',
    exact: true,
    component: Page.Register,
  },
  {
    path: '/cpap',
    exact: true,
    component: Page.Cpap,
  },
  {
    path: '/cpap/detail',
    exact: true,
    component: Page.CpapDetail,
  },
  {
    path: '/cpap/edit',
    exact: true,
    component: Page.CpapEdit,
  },
  {
    path: '/billing_process',
    exact: true,
    component: Page.BillingProcess,
  },
  {
    path: '/billing_process/register',
    exact: true,
    component: Page.BillingProcessRegister,
  },
  {
    path: '/billings',
    exact: true,
    component: Page.ListBilling,
  },
  {
    path: '/billings/detail',
    exact: true,
    component: Page.ListBillingUsage,
  },
  {
    path: '/consultation_history',
    exact: true,
    component: Page.ConsultationHistory,
  },
  {
    path: '/payouts',
    exact: true,
    component: Page.DepositManagement,
  },
  {
    path: '/machine/register',
    exact: true,
    component: Page.MachineRegister,
  },
  {
    path: '/machine',
    exact: true,
    component: Page.ListMachine,
  },
  {
    path: '/machine/update',
    exact: true,
    component: Page.MachineUpdate,
  },
  {
    path: '/machine/edit',
    exact: true,
    component: Page.MachineEdit,
  },
  {
    path: '/machine/detail',
    exact: true,
    component: Page.MachineDetail,
  },
  {
    path: '/machine/detail-lease',
    exact: true,
    component: Page.DetailAfterEndLease,
  },
  {
    path: '/medical_institution/register',
    exact: true,
    component: Page.MedicalInstitutionRegister,
  },
  {
    path: '/medical_institution/detail',
    exact: true,
    component: Page.MedicalInstitutionDetail,
  },
  {
    path: '/medical_institution/edit',
    exact: true,
    component: Page.MedicalInstitutionEdit,
  },
  {
    path: '/medical_institution',
    exact: true,
    component: Page.ListMedicalInstitution,
  },
];
